const gameBoard = {
    element: document.querySelector('#game-board'),
    height: 400,
    width: 1000,
};

export default gameBoard;
